import Payroll from '../../API/Payroll/Payroll.js'
import React, { useCallback, useEffect, useState } from 'react'
import { IoCloseSharp } from 'react-icons/io5'
import PDFButton from './pdfPayslip.jsx'
import Loading from '../Loading/Loading.jsx'

const DetailsPayslip = ({ onCloseDetails, employeeData, onUpdateEmployee }) => {
	const [data2, setData2] = useState()
	const [originalData, setOriginalData] = useState()
	const [isModified, setIsModified] = useState(false)
	const [loading, setLoading] = useState(false)
	const [loadingUpdate, setLoadingUpdate] = useState(false)

	const editDisabled = employeeData.validatedBy

	const handleInputChange = e => {
		const { name, value } = e.target
		const originalValue = originalData?.[name]

		const updatedValue = typeof originalValue === 'number' ? Number(value) : value

		const updatedData = { ...data2, [name]: updatedValue }
		setData2(updatedData)

		setIsModified(JSON.stringify(updatedData) !== JSON.stringify(originalData))
	}

	const fetchData = useCallback(async () => {
		try {
			const [respData] = await Promise.all([Payroll.getPayrollData(employeeData.id)])
			setData2(respData)
			setOriginalData(respData)
		} catch (error) {
			console.error('Error:', error)
		}
	}, [])

	useEffect(() => {
		fetchData()
	}, [fetchData])

	const handleUpdate = async () => {
		setLoadingUpdate(true)

		const updatedData = { ...data2, id: employeeData.id }

		try {
			await Payroll.updatePayroll(employeeData.id, data2)
			onUpdateEmployee(updatedData)
		} catch (error) {
			console.error(`Erro ao subir dados colaborador ${employeeData.id}:`, error)
		} finally {
			setLoadingUpdate(false)
			setIsModified(false)
		}
	}

	return (
		<>
			{loading ? (
				<Loading />
			) : (
				<>
					{data2 && (
						<div className='tw-fixed tw-inset-0 tw-flex  tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50'>
							<div className='tw-bg-white tw-p-4'>
								<div className='tw-bg-white tw-rounded-lg tw-h-[480px] 2xl:tw-h-[700px] md:tw-w-[900px] tw-p-6 tw-overflow-y-auto tw-space-y-5 tw-overflow-x-hidden'>
									{loadingUpdate ? (
										<Loading />
									) : (
										<>
											<div className='tw-flex tw-justify-end'>
												<div
													className='tw-flex tw-items-center tw-p-1 tw-h-6 tw-w-6 tw-bg-purple-500 tw-text-white tw-rounded-full tw-cursor-pointer'
													onClick={onCloseDetails}
												>
													<IoCloseSharp />
												</div>
											</div>

											<div className='tw-flex tw-justify-between tw-items-center tw-mb-5'>
												<div className='tw-text-left tw-w-1/3'>
													<div className='tw-text-xl tw-font-bold'>
														REMUNERACIONES MES DE: {data2.month} del {data2.year}
													</div>
												</div>

												<div className='tw-text-right tw-flex tw-flex-col tw-items-end tw-w-2/3'>
													<div className='tw-text-right tw-flex tw-space-x-4'>
														<div className='tw-text-black tw-font-bold'>{data2.legalName}</div>
														<div className='tw-text-gray-500'>
															RUT <span className='tw-text-black tw-ml-2'>{data2.companyDocument}</span>
														</div>
													</div>
													<div className='tw-text-gray-500'>{data2.address} </div>
												</div>
											</div>

											<div className='tw-space-y-4'>
												{/* Colaborador Document */}
												<div className='tw-flex tw-justify-between tw-items-center border tw-rounded tw-p-2 tw-text-sm tw-text-gray-700'>
													<div className='tw-flex-1 tw-flex tw-items-center tw-pr-4' style={{ borderRight: '1px solid #e5e7eb' }}>
														<strong className='tw-mr-4'>Nombre:</strong>{' '}
														<CustomInput name='name' value={data2.name} onChange={handleInputChange} editDisabled={editDisabled} />
													</div>
													<div className='tw-flex-1 tw-flex tw-items-center tw-pl-4 tw-pr-4' style={{ borderRight: '1px solid #e5e7eb' }}>
														<strong className='tw-mr-4'>Cargo:</strong>{' '}
														<CustomInput name='jobPosition' value={data2.jobPosition} onChange={handleInputChange} editDisabled={editDisabled} />
													</div>
													<div className='tw-flex tw-items-center tw-pl-4 tw-flex-shrink-0 tw-gap-2'>
														<strong className='tw-mr-4'>RUT:</strong>{' '}
														<div className='tw-w-[70px]'>
															<CustomInput
																name='employeeDocument'
																value={data2.employeeDocument}
																onChange={handleInputChange}
																editDisabled={editDisabled}
															/>
														</div>
														<span className='tw-mx-1'>-</span>
														<div className='tw-w-[30px]'>
															<CustomInput name='digit' value={data2.digit} onChange={handleInputChange} editDisabled={editDisabled} />
														</div>
													</div>
												</div>
											</div>

											<div className='tw-grid tw-grid-cols-2 tw-gap-6 tw-text-sm'>
												{/* Haberes */}
												<div className='tw-space-y-4'>
													<div className='border-bottom   tw-mb-2'>
														<div className='tw-font-bold tw-text-base tw-rounded-xl tw-bg-gray-200 tw-px-2 tw-py-1'>Haberes</div>
														<div className='tw-p-2'>
															<div>
																<span className='tw-mr-4'>Días Trabajados :</span>{' '}
																<CustomInput
																	name='daysWorked30'
																	value={data2.daysWorked30}
																	onChange={handleInputChange}
																	editDisabled={editDisabled}
																/>
															</div>
															<div>
																<span className='tw-mr-4'>Sueldo Base :</span> ${' '}
																<CustomInput name='baseSalary' value={data2.baseSalary} onChange={handleInputChange} editDisabled={editDisabled} />
															</div>
															<div className='border-bottom   tw-mb-2'>
																<span className='tw-mr-4'>Gratificación Legal :</span> ${' '}
																<CustomInput name='gratuity' value={data2.gratuity} onChange={handleInputChange} editDisabled={editDisabled} />
															</div>
															<div>
																<span className='tw-mr-4'>Bonus (verificar):</span> ${' '}
																<CustomInput name='bonus' value={2000} onChange={handleInputChange} editDisabled={editDisabled} />
															</div>
															<div>
																<span className='tw-mr-4'>Comisiones (verificar):</span> ${' '}
																<CustomInput name='bonus' value={200} onChange={handleInputChange} editDisabled={editDisabled} />
															</div>
															{data2.schoolEarnings !== undefined && data2.schoolEarnings !== null && (
																<div>
																	<span className='tw-mr-4'>Haber Colegio:</span> ${' '}
																	<CustomInput
																		name='schoolEarnings'
																		value={data2.schoolEarnings}
																		onChange={handleInputChange}
																		editDisabled={editDisabled}
																	/>
																</div>
															)}
															{data2.teacherHours !== undefined && data2.teacherHours !== null && (
																<div>
																	<span className='tw-mr-4'>Horas Profesor:</span> ${' '}
																	<CustomInput
																		name='teacherHours'
																		value={data2.teacherHours}
																		onChange={handleInputChange}
																		editDisabled={editDisabled}
																	/>
																</div>
															)}
															{data2.overtime !== undefined && data2.overtime !== null && (
																<div>
																	<span className='tw-mr-4'>Hora Extraordinaria:</span> ${' '}
																	<CustomInput name='overtime' value={data2.overtime} onChange={handleInputChange} editDisabled={editDisabled} />
																</div>
															)}
															{data2.sundayHours !== undefined && data2.sundayHours !== null && (
																<div>
																	<span className='tw-mr-4'>Domingos y Festivos :</span>{' '}
																	<CustomInput
																		name='sundayHours'
																		value={data2.sundayHours}
																		onChange={handleInputChange}
																		editDisabled={editDisabled}
																	/>
																</div>
															)}
															{data2.sundayValue !== undefined && data2.sundayValue !== null && (
																<div>
																	<span className='tw-mr-4'>Domingos y Festivos :</span> ${' '}
																	<CustomInput
																		name='sundayValue'
																		value={data2.sundayValue}
																		onChange={handleInputChange}
																		editDisabled={editDisabled}
																	/>
																</div>
															)}
														</div>
													</div>

													<div>
														<div className='tw-pl-2'>
															Total Imponible: <span className='tw-mr-4'>$ {data2.totalTaxable}</span>{' '}
														</div>

														<div className='tw-p-2'>
															{data2.numberOfDependents !== undefined && data2.numberOfDependents !== null && (
																<div>
																	<span className='tw-mr-4'>Cargas Familiares :</span>{' '}
																	<CustomInput
																		name='numberOfDependents'
																		value={data2.numberOfDependents}
																		onChange={handleInputChange}
																		editDisabled={editDisabled}
																	/>
																</div>
															)}
															{data2.dependentsBenefit !== undefined && data2.dependentsBenefit !== null && (
																<div>
																	<span className='tw-mr-4'>Cargas Familiares :</span> ${' '}
																	<CustomInput
																		name='dependentsBenefit'
																		value={data2.dependentsBenefit}
																		onChange={handleInputChange}
																		editDisabled={editDisabled}
																	/>
																</div>
															)}
															{data2.retroactiveDependentsBenefit !== undefined && data2.retroactiveDependentsBenefit !== null && (
																<div>
																	<span className='tw-mr-4'>Cargas Retroactivas :</span> ${' '}
																	<CustomInput
																		name='retroactiveDependentsBenefit'
																		value={data2.retroactiveDependentsBenefit}
																		onChange={handleInputChange}
																		editDisabled={editDisabled}
																	/>
																</div>
															)}
															<div>
																<span className='tw-mr-4'>Asignación Colación:</span> ${' '}
																<CustomInput name='mealBenefit' value={data2.mealBenefit} onChange={handleInputChange} editDisabled={editDisabled} />
															</div>
															<div>
																<span className='tw-mr-4'>Asignación Movilización:</span> ${' '}
																<CustomInput
																	name='transportBenefit'
																	value={data2.transportBenefit}
																	onChange={handleInputChange}
																	editDisabled={editDisabled}
																/>
															</div>
															{data2.otherBenefits !== undefined && data2.otherBenefits !== null && (
																<div>
																	<span className='tw-mr-4'>Otros:</span> ${' '}
																	<CustomInput
																		name='otherBenefits'
																		value={data2.otherBenefits}
																		onChange={handleInputChange}
																		editDisabled={editDisabled}
																	/>
																</div>
															)}
														</div>
													</div>
												</div>

												{/* Descuentos */}
												<div className='tw-space-y-4'>
													<div className='tw-font-bold tw-text-base tw-rounded-xl tw-bg-gray-200 tw-px-2 tw-py-1'>Descuentos</div>
													<div className='tw-p-2 border-bottom'>
														<div>
															<span className='tw-mr-4'>
																AFP: <span className='tw-text-gray-500 tw-mx-4'>{data2.pensionPlan} </span>{' '}
															</span>{' '}
														</div>
														<div>
															<span className='tw-mr-4'>Cotización AFP:</span> ${' '}
															<CustomInput
																name='pensionContribution'
																value={data2.pensionContribution}
																onChange={handleInputChange}
																editDisabled={editDisabled}
															/>
														</div>
													</div>

													{data2.voluntaryPensionContribution !== undefined && data2.voluntaryPensionContribution !== null && (
														<div className='tw-p-2 border-bottom'>
															<div>
																<span className='tw-mr-4'>
																	AFP (cuenta 2): <span className='tw-text-gray-500 tw-mx-4'>{data2.voluntaryPensionContribution}</span>{' '}
																</span>{' '}
															</div>
														</div>
													)}

													<div className='tw-p-2 border-bottom'>
														<div>
															<span className='tw-mr-4'>
																Isapre:{' '}
																<span className='tw-text-gray-500 tw-mx-4'>
																	<span>{data2.healthPlan}</span>{' '}
																</span>{' '}
															</span>{' '}
														</div>
														<div>
															<span className='tw-mr-4'>7% Obligatorio:</span> ${' '}
															<CustomInput
																name='healthContribuition'
																value={data2.healthContribuition}
																onChange={handleInputChange}
																editDisabled={editDisabled}
															/>
														</div>
													</div>

													{data2.unemploymentInsuranceContribution !== undefined && data2.unemploymentInsuranceContribution !== null && (
														<div className='tw-p-2 border-bottom'>
															<div>
																<span className='tw-mr-4'>Cotización AFC : </span>${' '}
																<CustomInput
																	name='unemploymentInsuranceContribution'
																	value={data2.unemploymentInsuranceContribution}
																	onChange={handleInputChange}
																	editDisabled={editDisabled}
																/>
															</div>
														</div>
													)}

													<div className='tw-p-2 border-bottom'>
														{data2.leaveDays !== undefined && data2.leaveDays !== null && (
															<div>
																<span className='tw-mr-4'>Licencias: </span>${' '}
																<CustomInput name='leaveDays' value={data2.leaveDays} onChange={handleInputChange} editDisabled={editDisabled} />
															</div>
														)}
														{data2.absenceDays !== undefined && data2.absenceDays !== null && (
															<div>
																<span className='tw-mr-4'>Faltas: </span>{' '}
																<CustomInput name='absenceDays' value={data2.absenceDays} onChange={handleInputChange} editDisabled={editDisabled} />
															</div>
														)}
														{data2.hoursLate !== undefined && data2.hoursLate !== null && (
															<div>
																<span className='tw-mr-4'>Horas Atraso: </span>{' '}
																<CustomInput name='hoursLate' value={data2.hoursLate} onChange={handleInputChange} editDisabled={editDisabled} />
															</div>
														)}
														{data2.delays !== undefined && data2.delays !== null && (
															<div>
																<span className='tw-mr-4'>Atrasos: </span>{' '}
																<CustomInput name='delays' value={data2.delays} onChange={handleInputChange} editDisabled={editDisabled} />
															</div>
														)}
														{data2.solidarityLoan !== undefined && data2.solidarityLoan !== null && (
															<div>
																<span className='tw-mr-4'>Prestamo Solidario: </span>${' '}
																<CustomInput
																	name='solidarityLoan'
																	value={data2.solidarityLoan}
																	onChange={handleInputChange}
																	editDisabled={editDisabled}
																/>
															</div>
														)}
														{data2.advancePayment !== undefined && data2.advancePayment !== null && (
															<div>
																<span className='tw-mr-4'>Antecipos: </span>${' '}
																<CustomInput
																	name='advancePayment'
																	value={data2.advancePayment}
																	onChange={handleInputChange}
																	editDisabled={editDisabled}
																/>
															</div>
														)}
														{data2.compensationFundInsurence !== undefined && data2.compensationFundInsurence !== null && (
															<div>
																<span className='tw-mr-4'>Seguro CCAF: </span>${' '}
																<CustomInput
																	name='compensationFundInsurence'
																	value={data2.compensationFundInsurence}
																	onChange={handleInputChange}
																	editDisabled={editDisabled}
																/>
															</div>
														)}
														{data2.compensationFundLoan !== undefined && data2.compensationFundLoan !== null && (
															<div>
																<span className='tw-mr-4'>Prestamo CCAF: </span>${' '}
																<CustomInput
																	name='compensationFundLoan'
																	value={data2.compensationFundLoan}
																	onChange={handleInputChange}
																	editDisabled={editDisabled}
																/>
															</div>
														)}
														{data2.compensationFundLoan !== undefined && data2.compensationFundLoan !== null && (
															<div>
																<span className='tw-mr-4'>Prestamo CCAF: </span>${' '}
																<CustomInput
																	name='compensationFundLoan'
																	value={data2.compensationFundLoan}
																	onChange={handleInputChange}
																	editDisabled={editDisabled}
																/>
															</div>
														)}
														{data2.companyLoan !== undefined && data2.companyLoan !== null && (
															<div>
																<span className='tw-mr-4'>Prestamo CCAF: </span>${' '}
																<CustomInput name='companyLoan' value={data2.companyLoan} onChange={handleInputChange} editDisabled={editDisabled} />
															</div>
														)}
														{data2.voluntaryPensionSavingsContribution !== undefined && data2.voluntaryPensionSavingsContribution !== null && (
															<div>
																<span className='tw-mr-4'>APV vol.: </span>${' '}
																<CustomInput
																	name='voluntaryPensionSavingsContribution'
																	value={data2.voluntaryPensionSavingsContribution}
																	onChange={handleInputChange}
																	editDisabled={editDisabled}
																/>
															</div>
														)}
														{data2.voluntaryPensionSavingsContribution2 !== undefined && data2.voluntaryPensionSavingsContribution2 !== null && (
															<div>
																<span className='tw-mr-4'>APV vol. II: </span>${' '}
																<CustomInput
																	name='voluntaryPensionSavingsContribution2'
																	value={data2.voluntaryPensionSavingsContribution2}
																	onChange={handleInputChange}
																	editDisabled={editDisabled}
																/>
															</div>
														)}
														{data2.collectivePensionContribuition !== undefined && data2.collectivePensionContribuition !== null && (
															<div>
																<span className='tw-mr-4'>APV vol. Colectivo: </span>${' '}
																<CustomInput
																	name='collectivePensionContribuition'
																	value={data2.collectivePensionContribuition}
																	onChange={handleInputChange}
																	editDisabled={editDisabled}
																/>
															</div>
														)}
													</div>

													<div className='tw-p-2'>
														<div>
															<span className='tw-mr-4'>Base Tributable: </span>${' '}
															<CustomInput name='taxableBase' value={data2.taxableBase} onChange={handleInputChange} editDisabled={editDisabled} />
														</div>
														<div>
															<span className='tw-mr-4'>Impuestos: </span>{' '}
															<CustomInput name='taxes' value={data2.taxes} onChange={handleInputChange} editDisabled={editDisabled} />
														</div>
													</div>
												</div>
											</div>

											<div className='tw-grid tw-grid-cols-2 tw-gap-6 tw-text-sm border-top'>
												<div className='tw-mt-4'>
													<div>
														<strong>Total Haberes:</strong> ${' '}
														<CustomInput name='totalEarnings' value={data2.totalEarnings} onChange={handleInputChange} editDisabled={editDisabled} />
													</div>
													<div>
														<span>Fecha:</span>{' '}
														<CustomInput name='fecha' value={data2.fecha} onChange={handleInputChange} editDisabled={editDisabled} />
													</div>
												</div>
												<div className='tw-mt-4'>
													<div>
														<span className='tw-mr-4'>Total Descuentos:</span> ${' '}
														<CustomInput
															name='totalDiscounts'
															value={data2.totalDiscounts}
															onChange={handleInputChange}
															editDisabled={editDisabled}
														/>
													</div>
													<div className='border-bottom'>
														<strong className='tw-mr-4'>Alcance Líquido:</strong> ${' '}
														<CustomInput name='totalPayable' value={data2.totalPayable} onChange={handleInputChange} editDisabled={editDisabled} />
													</div>
												</div>
											</div>
										</>
									)}
								</div>

								{!loadingUpdate && (
									<div className='tw-flex tw-w-full tw-gap-4 tw-mt-6 tw-justify-center'>
										<div
											className='tw-bg-gray-300 tw-text-gray-700 tw-px-4 tw-py-2 tw-rounded-3xl tw-text-center tw-flex-1 tw-cursor-pointer'
											onClick={onCloseDetails}
										>
											Cerrar
										</div>

										{isModified ? (
											<div
												className='tw-bg-blue-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-3xl tw-text-center tw-flex-1 tw-cursor-pointer'
												onClick={handleUpdate}
											>
												Atualizar Liquidación
											</div>
										) : (
											<PDFButton data={data2} active={true} />
										)}
									</div>
								)}
							</div>
						</div>
					)}
				</>
			)}
		</>
	)
}

const CustomInput = ({ name, value, onChange, editDisabled }) => {
	return (
		<input
			type='text'
			name={name}
			value={value}
			onChange={onChange}
			autoComplete='off'
			style={{
				backgroundColor: 'transparent',
				border: 'none',
				outline: 'none',
				color: 'inherit',
				padding: '0',
				margin: '0',
			}}
			disabled={editDisabled}
		/>
	)
}

export default DetailsPayslip
